const getSort = (sortBy) => {
  switch (sortBy) {
    case "createdAt":
      return { createdAt: "desc" };
    case "image_score":
    default:
      return { image_score: "desc" };
  }
};

export const getQueryParams = ({
  pageNumber,
  selectedTag = "All",
  digitalProfileId,
  sortBy,
}) => {
  const baseFilters = {
    sort: getSort(sortBy),
    filters: {
      project: {
        digital_profile: {
          $eq: digitalProfileId,
        },
      },
      moderation_status: {
        $eq: "confirmed",
      },
      media_metadata: {
        is_valid: {
          $eq: true,
        },
      },
      // image_score: {
      //   $gt: 0,
      // },
    },
    pagination: {
      page: pageNumber,
      pageSize: 15,
    },
  };
  if (selectedTag !== "All") {
    return {
      ...baseFilters,
      filters: {
        ...baseFilters.filters,
        tag_id: {
          tag: {
            $eq: selectedTag,
          },
        },
      },
    };
  }
  return baseFilters;
};
